import { RootState } from '../../../base';
import { createSelector } from 'reselect';
import { tablesSelectors } from '../../tables/redux/selectors';
import { TableIds } from '../../../common';

export const jobApplicationSelectors = {
    getApplyNowLoading: (state: RootState) =>
        state.jobApplication.uiState.isApplyNowLoading,
    getActiveJobApplication: (state: RootState) =>
        state.jobApplication.activeJobApplication,
    getActiveJobApplicationJobId: (state: RootState) =>
        state.jobApplication.activeJobApplication?.job?.id,
    getJobIdSuccessfullyApplied: (state: RootState) =>
        state.jobApplication.jobIdSuccessfullyApplied,
    getJobApplicationsStatistics: (state: RootState) =>
        state.jobApplication.jobApplicationsStatistics,
    getIsUpdateJobApplicationStatusLoading: (state: RootState) =>
        state.jobApplication.uiState.isUpdateJobApplicationStatusLoading,
    getJobApplicationsIds: (state: RootState) => getJobApplicationsIds(state),
    getNextJobApplicationsId: (state: RootState) =>
        getNextJobApplicationsId(state),
    getPreviousJobApplicationsId: (state: RootState) =>
        getPreviousJobApplicationsId(state),
    getIsRejectApplicationModalOpen: (state: RootState) =>
        state.jobApplication.uiState.isRejectApplicationModalOpen,
    getRejectApplicationModalData: (state: RootState) =>
        state.jobApplication.rejectApplicationModalData,
    getIsTransferCandidateModalOpen: (state: RootState) =>
        state.jobApplication.uiState.isTransferCandidateModalOpen,
    getTransferCandidateModalData: (state: RootState) =>
        state.jobApplication.transferCandidateModalData,
    getIsTransferCandidateLoading: (state: RootState) =>
        state.jobApplication.uiState.isTransferCandidateLoading,
    getIsScheduleInterviewLoading: (state: RootState) =>
        state.jobApplication.uiState.isScheduleInterviewLoading,
    getScheduleInterviewResult: (state: RootState) =>
        state.jobApplication.uiState.scheduleInterviewResult,
    getIsBulkRejectApplicationModalOpen: (state: RootState) =>
        state.jobApplication.uiState.isBulkRejectApplicationModalOpen,
    getBulkRejectApplicationModalData: (state: RootState) =>
        state.jobApplication.bulkRejectApplicationModalData,
    getIsBulkRejectApplicationLoading: (state: RootState) =>
        state.jobApplication.uiState.isBulkRejectApplicationLoading,
};

const getJobApplicationsIds = createSelector(
    [
        (state: RootState) =>
            tablesSelectors.getRowsData(state, TableIds.JOB_APPLICATIONS),
    ],
    (candidates) => {
        if (!candidates) return null;
        return candidates?.map((candidate) => Number(candidate.id));
    }
);

const getNextJobApplicationsId = createSelector(
    [
        jobApplicationSelectors.getJobApplicationsIds,
        jobApplicationSelectors.getActiveJobApplication,
    ],
    (candidates, activeJobApplication) => {
        if (!candidates || !activeJobApplication) return null;
        const currentIndex = candidates.indexOf(activeJobApplication.id);
        if (currentIndex + 1 > candidates.length - 1) return null;
        return candidates[currentIndex + 1];
    }
);

const getPreviousJobApplicationsId = createSelector(
    [
        jobApplicationSelectors.getJobApplicationsIds,
        jobApplicationSelectors.getActiveJobApplication,
    ],
    (candidates, activeJobApplication) => {
        if (!candidates || !activeJobApplication) return null;
        const currentIndex = candidates.indexOf(activeJobApplication.id);
        if (currentIndex - 1 < 0) return null;
        return candidates[currentIndex - 1];
    }
);
